export default {
    manage_deleteLocation_title: "Delete Location",
    manage_deleteLocations_title: "Delete Locations",
    manage_deleteLocations_description: "Are you sure you want to delete the Locations?",
    manage_deleteLocation_description: "Are you sure you want to delete this Location?",
    manage_deleteLocation_successMessage: "Location deleted",
    manage_deleteLocations_successMessage: "Locations deleted",
    manage_deleteLocations_are_in_use: "It is not possible to delete locations in use",
}